module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/i18next-browser-languagedetector/index.js
// module id = 298
// module chunks = 0